module.exports = __webpack_public_path__ + "d16d814f43c10883cf10a514ed0f22f2.png";